import script from "./testimoniosView.vue?vue&type=script&setup=true&lang=ts"
export * from "./testimoniosView.vue?vue&type=script&setup=true&lang=ts"

import "./testimoniosView.vue?vue&type=style&index=0&id=24b8c470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b8c470"]])

export default __exports__